export default class DocumentTrackerSettings {
    constructor(dto) {
        this.title = '';
        this.color = '';
        this.contentTypeIDs = [];
        this.stateFieldCode = '';
        this.stateFieldValue = [];
        this.dateFieldCode = '';
        this.warningDays = 0;
        this.fieldsToShow = [];
        this.expiredColor = '#ff5252';
        this.warningColor = '#fb8c00';
        this.onTimeColor = '#4caf50';
        this.expiredTextColor = '#ffffff';
        this.warningTextColor = '#ffffff';
        this.onTimeTextColor = '#ffffff';
        this.showDocumentOnOpeningModal = false;
        this.enableHorizontalScrolling = false;

        if (dto) {
            this.title = dto.Title || '';
            this.color = dto.Color || '';
            this.stateFieldCode = dto.StateFieldCode || '';
            this.stateFieldValue = (dto.StateFieldValue || '').split(',').filter(x => x);
            this.dateFieldCode = dto.DateFieldCode || '';
            if (dto.ContentTypeIDs) this.contentTypeIDs = dto.ContentTypeIDs.split(',');
            if (dto.WarningDays) this.warningDays = parseInt(dto.WarningDays);
            if (dto.FieldsToShow) this.fieldsToShow = dto.FieldsToShow.split(',');

            this.expiredColor = dto.ExpiredColor || '#ff5252';
            this.warningColor = dto.WarningColor || '#fb8c00';
            this.onTimeColor = dto.OnTimeColor || '#4caf50';
            this.expiredTextColor = dto.ExpiredTextColor || '#ffffff';
            this.warningTextColor = dto.WarningTextColor || '#ffffff';
            this.onTimeTextColor = dto.OnTimeTextColor || '#ffffff';
            this.showDocumentOnOpeningModal = dto.ShowDocumentOnOpeningModal == 'true';
            this.enableHorizontalScrolling = dto.EnableHorizontalScrolling == 'true';
        }
    }

    toDto() {
        return {
            Title: this.title,
            Color: this.color,
            StateFieldCode: this.stateFieldCode,
            StateFieldValue: this.stateFieldValue.filter(x => x).join(','),
            DateFieldCode: this.dateFieldCode,
            WarningDays: this.warningDays.toString(),
            ContentTypeIDs: this.contentTypeIDs.length == 0 ? '' : this.contentTypeIDs.join(','),
            FieldsToShow: this.fieldsToShow.length == 0 ? '' : this.fieldsToShow.join(','),
            ExpiredTextColor: this.expiredTextColor,
            ExpiredColor: this.expiredColor,
            WarningColor: this.warningColor,
            WarningTextColor: this.warningTextColor,
            OnTimeTextColor: this.onTimeTextColor,
            OnTimeColor: this.onTimeColor,
            ShowDocumentOnOpeningModal: this.showDocumentOnOpeningModal.toString(),
            EnableHorizontalScrolling: this.enableHorizontalScrolling.toString(),
        };
    }
}
